import { useState, useEffect, useRef } from 'react';
import { Popover } from '@material-ui/core';
import { Calendar } from 'react-date-range';
import CustomButton from 'shared_ui_components/CustomButton';
import { format } from 'date-fns';
import { useTimezoneStore } from 'infrastructure/useTimeZoneStore';
import NewDateTime from 'infrastructure/NewDateTime';

export default function NewDatePicker(props) {
  const { timezone } = useTimezoneStore();
  const { defaultFilter = {}, handleApply = () => null } = props;

  const [date, setDate] = useState(() => {
    try {
      if (defaultFilter.date) {
        return new Date(defaultFilter.date);
      }
      return NewDateTime.getCurrentUserMidnight();
    } catch {
      return new Date();
    }
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const previousTimezone = useRef(timezone);

  useEffect(() => {
    if (previousTimezone.current !== timezone) {
      previousTimezone.current = timezone;
      const newDate = NewDateTime.toUserTzDate(date);
      setDate(newDate);
    }
  }, [timezone, date]);

  useEffect(() => {
    try {
      if (defaultFilter.date) {
        const newDate = new Date(defaultFilter.date);
        if (!isNaN(newDate)) {
          setDate(newDate);
        }
      }
    } catch (error) {
      console.error('Error updating date from props:', error);
    }
  }, [defaultFilter.date]);

  const handleClose = () => setAnchorEl(null);
  const handleOpenFilter = (e) => setAnchorEl(e.currentTarget);

  const handleSubmit = () => {    
    handleApply(format(date,'yyyy-MM-dd').split('T')[0] + ' 00:00:00');
    handleClose();
  };

  const handleDateChange = (newDate) => {
    if (newDate instanceof Date && !isNaN(newDate)) {
      setDate(newDate);
    }
  };
  const minDate = NewDateTime.getCurrentUserMidnight();

  return (
    <div className="dateRangeFilterWrapper">
      <div className="dateValues" onClick={handleOpenFilter}>
        <p className="heading6">
          <span>{date ? format(date, 'MMM dd, yyyy') : 'Select date'}</span>
        </p>
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        className="dateRangeSelectPopup"
      >
        <div className="dateRangeSelectWrapper">
          <div className="dateRangePicker">
            <Calendar onChange={handleDateChange} date={date} minDate={minDate} />
          </div>
          <div className="footer">
            <ul className="listInline">
              <li className="listInlineItem">
                <CustomButton className="tertiaryBtn smallBtn" onClick={handleClose}>
                  {'Cancel'}
                </CustomButton>
              </li>
              <li className="listInlineItem">
                <CustomButton onClick={handleSubmit} className={`primaryBtn smallBtn`}>
                  Apply
                </CustomButton>
              </li>
            </ul>
          </div>
        </div>
      </Popover>
    </div>
  );
}
